export enum NotificationsFilterActionType {
  None = 0,
  SetQuery,
  UnsetQuery,
  SetStatus,
  UnsetStatus,
  ClearAll
}
